// extracted by mini-css-extract-plugin
export default {"container":"profile-form-container_container__qhgGA","links":"profile-form-container_links__ofK7D"};